import React, { useState } from 'react';

import Card from '@mui/material/Card';

import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useTranslation } from 'react-i18next';

const ITEM_HEIGHT = 48;

const MenuDropdown = ({ onDelete, onUpdate, resource, color }) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (event) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  const options = [
    {
      name: t('edit'),
      handleClick: (event) => {
        event.stopPropagation();
        onUpdate(resource);
        setAnchorEl(null);
      },
    },
    {
      name: t('delete'),
      handleClick: (event) => {
        event.stopPropagation();
        onDelete(resource);
        setAnchorEl(null);
      },
    },
  ];

  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        sx={{ color: color }} // Changer la couleur de l'icône en blanc
        size="small">
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          'aria-labelledby': 'long-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: '20ch',
          },
        }}>
        {options.map((option, index) => (
          <MenuItem key={index} onClick={option.handleClick}>
            {option.name}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default MenuDropdown;
